export default __webpack_public_path__ + "static/media/02.d2f3b1f0.jpg";